module.exports = __webpack_public_path__ + "static/media/home_logo.808e1826.png";